import { Table } from "@/features/Table";
import { type C8StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterC8StaticDatumsSchema,
  FilterC8StaticDatums,
} from "./filter";

const client = "c8";
const table_name = "c8_static_data";

export const C8StaticDatumsTable = () => {
  return (
    <Table<C8StaticDatum, FilterC8StaticDatumsSchema>
      label="Actifs"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterC8StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
